import clsx from 'clsx';
import { ComponentProps, FC, ReactNode } from 'react';

import styles from './Text.module.scss';

export type TextProps = Omit<ComponentProps<'span' | 'h1' | 'h2' | 'h3'>, 'color' | 'ref'> & {
  type?: `h${1 | 2 | 3}` | `body16` | 'button14' | `regular${12 | 14 | 16 | 18 | 48}` | `medium${14 | 16 | 18 | 64}`;
  align?: 'left' | 'center' | 'right';
  whiteSpace?: 'normal' | 'preWrap';
  color?: 'white' | 'white50' | 'green' | 'green26';
  lineCount?: number;
  withEllipsis?: boolean;
  children: ReactNode;
};

export const Text: FC<TextProps> = (props) => {
  const { className, type, align, whiteSpace, color, withEllipsis, style, ...typographyProps } = props;

  return (
    <span
      className={clsx(
        styles.root,
        styles[`type_${type}`],
        color && styles[color],
        align && styles[`align_${align}`],
        whiteSpace && styles[`whiteSpace_${whiteSpace}`],
        withEllipsis && styles.withEllipsis,
        className
      )}
      style={style}
      {...typographyProps}
    />
  );
};
